import { Injectable } from '@angular/core';

// export class Retail implements OnInit {

@Injectable({
    providedIn: 'root'
})
//--
export class Company {
        
    name = "บริษัท บริหารสินทรัพย์ ไนท คลับ แคปปิตอล จำกัด (มหาชน)";

}
//--
export class Retail {
        
    port1 = "HP1";
    port2 = "HP2";
    port3 = "HP2-1600";
    port4 = "HP2-2400";
    port5 = "CC-UPL1";
    port6 = "HP3";

}
//--
export class Housing {
        
    port01 = "SCB-HS1";
    port02 = "SCB-HS2";
    port03 = "TMB-HS3";
    port04 = "SCB-HS4";
    port05 = "SCB-HS5";

}
//--
export class SME {
        
    port01 = "ICBC-SME1";
    port02 = "SAM-SME1";
    port03 = "SAM-SME2";
    port04 = "SAM-SME3";
    port05 = "SCBT-SME1";
    port06 = "SCBT-SME2";
    port07 = "TMB-SME1";
    port08 = "OCBC-SME1";
    port09 = "BAM-SME1";
    port10 = "CIMB-SME1";

}
//--
export class Corporate {

    port01 = "SAM-CORP1";
    port02 = "SCBT-CORP1";
    port03 = "SCBT-CORP2";
    port04 = "SCBT-CORP3";

}
//--
export class Screen {

    userGroup   = "USER_GROUP";
    user        = "USER";
    groupRight  = "GROUP_RIGHT";
    //--
    noScreen  = "NO_SCREEN";

}

export class Right {

}
//--
export class LogType {

    error   = "ERROR";
    warning = "WARNING";
    info    = "INFO";

}
//--
export class LegalStep {

    step00  = "#0. รับลูกหนี้";
    step001 = "รับเอกสารฉบับจริง";
    step002 = "ส่งหนังสือบอกกล่าวฯ";
    step003 = "โอนสิทธิการรับจำนอง";
    step004 = "ยื่นสวมสิทธิในคดี";
    step01  = "#1. ยังไม่ฟ้อง";
    step02  = "#2. ฟ้องคดี";
    step03  = "#3. พิพากษา";
    step04  = "#4. อุทธรณ์, ฎีกา";
    step041 = "#4.1. อุทธรณ์";
    step042 = "#4.2. ฎีกา";
    stepX   = "เจ้าหนี้นอก";
    step05  = "#5. บังคับคดี";
    step06  = "#6. ประกาศขาย";
    step07  = "#7. ขายได้";
    step08  = "#8. รับเงินแล้ว";
    step09  = "#9. ทรัพย์ NPA";
    step10  = "#10. สืบทรัพย์";
    step11  = "#11. ฟ้องส่วนต่าง";
    step12  = "#12. ปิดบัญชี";

}
export class LegalStepSub {

    //--
    step0011 = "บันทึกรับเอกสารฉบับจริง";
    step0012 = "ระหว่างส่งหนังสือบอกกล่าวฯ";
    step0013 = "ระหว่างโอนสิทธิการรับจำนอง";
    step0014 = "ระหว่างยื่นสวมสิทธิในคดี";
    //--
    step0021 = "ระหว่างดำเนินการ";
    //--
    step0031 = "ระหว่างดำเนินการ";
    //--
    step0041 = "ระหว่างดำเนินการ";
    //--
    step0101 = "ระหว่างรับชำระหนี้ตาม TDR";
    step0102 = "ระหว่างส่งให้สำนักงาน (OA)"; //-- info
    //--
    step0201 = "เตรียมยื่นฟ้อง";
    step0202 = "ฟ้องคดี";
    step0203 = "นัดไต่สวน / สืบพยาน";
    step0204 = "เจ้าหนี้เดิมฟ้อง - ดำเนินคดี";
    //--
    step0301 = "ผลการพิพากษา";
    step0302 = "ระหว่างดำเนินการขั้นตอนต่อไป";
    step0303 = "ระหว่างรับชำระหนี้ตาม LTDR";
    step0304 = "ระหว่างรับชำระหนี้ตาม TDR+";
    //--
    step0411 = "อุทธรณ์คดี";
    step0412 = "ระหว่างดำเนินการขั้นตอนต่อไป";
    //--
    step0421 = "ยื่นฎีกา";
    step0422 = "ระหว่างดำเนินการขั้นตอนต่อไป";
    //--
    stepEX1 = "บันทึกเจ้าหนี้นอกยึด";
    stepEX2 = "ยื่นบุริมสิทธิ";
    stepEX3 = "เข้าร่วมการขายทอดตลาด";
    //--
    step0501 = "ระหว่างดำเนินการ";
    //--
    step0601 = "ขายทอดตลาด";
    //--
    step0701 = "กระบวนการรับเงิน";
    //--
    step0801 = "ระหว่างดำเนินการขั้นตอนต่อไป";
    //--
    step0901 = "จัดการทรัพย์ NPA";
    //--
    step1001 = "ระหว่างการสืบทรัพย์";
    //--
    step1101 = "เข้าร่วมการขายทอดตลาด";
    //--
    step1201 = "ลูกหนี้ในระบบ";
    step1202 = "ลูกหนี้ปิดบัญชีแล้ว";
    //--

}
//-- 2022-09-02
export class PortType {

    Housing    = "Housing";
    SME        = "SME";
    Corporate  = "Corporate";

}

//-- 2024-04-15
export class BankName {

    "BAY"    = "กรุงศรีอยุธยา";
    "BBL"    = "กรุงเทพ";
    "BNPP"   = "บีเอ็นพี พารีบาส์";
    "BOC"    = "แห่งประเทศจีน";
    "BofA"   = "แห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น";
    "CIMBT"  = "ซีไอเอ็มบี ไทย";
    "DBBK"   = "ดอยซ์แบงก์";
    "HSBC"   = "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น";
    "ICBCT"  = "ไอซีบีซี (ไทย)";
    "Indian" = "อินเดียนโอเวอร์ซีส์";
    "JPMCB"  = "เจพีมอร์แกน เชส";
    "KBANK"  = "กสิกรไทย";
    "KKP"    = "เกียรตินาคินภัทร";
    "KTB"    = "กรุงไทย";
    "LHBANK" = "แลนด์ แอนด์ เฮ้าส์";
    "Mega"   = "เมกะ สากลพาณิชย์";
    "MIZUHO" = "มิซูโฮ";
    "OCBC"   = "โอเวอร์ซี-ไชนิสแบงกิ้งคอร์ปอเรชั่น";
    "RHB"    = "อาร์ เอช บี";
    "SCB"    = "ไทยพาณิชย์";
    "SCBT"   = "สแตนดาร์ดชาร์เตอร์ด (ไทย)";
    "SMBT"   = "ซูมิโตโม มิตซุย ทรัสต์ (ไทย)";
    "SMBC"   = "ซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอร์เรชั่น";
    "TCR"    = "ไทยเครดิต";
    "TTB"    = "ทหารไทยธนชาต";
    "TISCO"  = "ทิสโก้";
    "UOBT"   = "ยูโอบี";

}
//--
export const BANK_ACCOUNTS = [
  {
    bankCode: 'TTB', // รหัสธนาคาร (อ้างอิงจาก BankName class)
    id: '1952346011', // เลขบัญชีสำหรับใช้ใน API
    displayName: '195-2-34601-1', // เลขบัญชีสำหรับแสดงผลที่ Tab
    isActive: true // (แนะนำ) เพิ่ม Flag สำหรับเปิด/ปิดการใช้งาน
  },
  {
    bankCode: 'TTB',
    id: '1952346672',
    displayName: '195-2-34667-2',
    isActive: true
  },
  {
    bankCode: 'KBANK',
    id: '1988541210', 
    displayName: '198-8-54121-0',
    isActive: true
  }
];
//--
export class NPAStatus {

    S1_TRANSFER = "1.ระหว่างการรับโอน";
    S2_NPA      = "2.NPA";
    S3_SALE     = "3.ประกาศขาย";
    S4_DEPOSIT  = "4.มัดจำซื้อทรัพย์";
    S5_SOLD     = "5.ขายแล้ว";

}
//--
export class NPAPriceStatus {

    PS1_WAIT_TRANSFER = "-";
    PS2_WAIT_APPROVE  = "รออนุมัติราคา";
    PS3_APPROVED      = "อนุมัติ";

}

